import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export interface IMyFileRow {
  id: string
  file_id: string
  name: string
  cdnLink?: string
  isSelected: boolean
  content_hash?: string | null
  transcription_status?: "pending" | "ready" | "failed" | null
  file_extension?: string
}

export async function getMyFilesNoSession(
  tokenInfo: ITokenInfo,
  params: { search?: string; tagIds?: string[] }
) {
  const { search = "", tagIds = [] } = params
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/library/my-files`
  return await axiosInstance({
    method: "POST",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: { search, tagIds }
  })
}

export async function searchMyFilesNoSession(
  tokenInfo: ITokenInfo,
  params: { query: string; offset: number; size: number }
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/library/my-files/search`
  return await axiosInstance({
    method: "POST",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: params
  })
}

// Knowledge Library — uses existing endpoint.
// `searchEntireLibrary` is the existing controller; the route is POST /copilot/library/search.
// BE destructures `query` (not `search`) from req.body — always send `query` on the wire.
export async function searchKnowledgeLibrary(
  tokenInfo: ITokenInfo,
  params: { search?: string; tagIds?: string[] }
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/library/search`
  const { search, tagIds } = params
  return await axiosInstance({
    method: "POST",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: { query: search ?? "", tagIds: tagIds ?? [] }
  })
}

// Presigned URL request that includes content_hash for tier-1 dedup
export async function requestPresignedUrls(
  tokenInfo: ITokenInfo,
  files: { name: string; content_hash: string | null }[]
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/copilot/proposal/rfp/presigned_urls`
  return await axiosInstance({
    method: "POST",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: {
      files,
      type: "GLOBAL_CONTEXT",
      show_my_files_in_rfp_response: true,
      is_session_independent: true,
      sessionId: ""
    }
  })
}

export async function notifyUserScopedUploaded(
  tokenInfo: ITokenInfo,
  files: { s3_path: string; content_hash: string | null }[]
) {
  const url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/user_scoped_files_uploaded`
  return await axiosInstance({
    method: "POST",
    url,
    headers: { Authorization: `Bearer ${tokenInfo?.token}` },
    data: { files }
  })
}
